import React, { Fragment, useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_ARTICULO_COMENTARIOS,
  ADD_COMENTARIO,
  GET_COMENTARIO_ID,
  REPLY_COMENTARIO,
} from '../../graphql/actions/comentario';
import { timeDifferenceForDate } from '../../util/timecheck';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
// @material-ui/icons
import Reply from '@material-ui/icons/Reply';
//import Favorite from '@material-ui/icons/Favorite';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Badge from '../UI/Badge/Badge';
import Button from '../UI/CustomButtons/Button';
import Media from '../UI/Media/Media';
import CustomInput from '../UI/CustomInput/CustomInput';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
import ArticuloRes from './ArticuloRes';
// Img
import avatar from '../../assets/img/user_avatar.jpg';
// Validations
import { isEmpty, isEmail } from '../../util/validators';

import sectionFullDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDetailsStyle';

const useStyles = makeStyles(sectionFullDataStyle);

const ArticuloComment = (props) => {
  const classes = useStyles();
  const [formAutor, setFormAutor] = useState('');
  const [formCorreo, setFormCorreo] = useState('');
  const [formContenido, setFormContenido] = useState('');
  const [addForm, setAddForm] = useState({
    autor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    correo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmail],
    },
    contenido: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [respuestaModal, setRespuestaModal] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of addForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'autor') {
        if (isValid) setFormAutor('success');
        else setFormAutor('error');
      }
      if (input === 'correo') {
        if (isValid) setFormCorreo('success');
        else setFormCorreo('error');
      }
      if (input === 'contenido') {
        if (isValid) setFormContenido('success');
        else setFormContenido('error');
      }
    }

    const updatedForm = {
      ...addForm,
      [input]: {
        ...addForm[input],
        valid: isValid,
        value: value,
      },
    };

    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setAddForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const respuestaShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_COMENTARIO_ID,
      data: { getComentarioId: id },
    });
    setRespuestaModal(true);
  };

  const respuestaCloseModalHandler = () => {
    setRespuestaModal(false);
  };

  const updateCacheAdd = (cache, { data }) => {
    const { getArticuloComentarios } = cache.readQuery({
      query: GET_ARTICULO_COMENTARIOS,
      variables: {
        paginate: {
          articulo: props.articuloId,
          numComentarios: 30,
          cursor: '',
          sortBy: { field: 'createdAt', order: 'ASC' },
        },
      },
    });

    const nuevoComentario = data?.createComentario;

    if (getArticuloComentarios && nuevoComentario) {
      cache.writeQuery({
        query: GET_ARTICULO_COMENTARIOS,
        variables: {
          paginate: {
            articulo: props.articuloId,
            numComentarios: 30,
            cursor: '',
            sortBy: { field: 'createdAt', order: 'ASC' },
          },
        },
        data: {
          getArticuloComentarios: {
            comentarios: [
              nuevoComentario,
              ...getArticuloComentarios?.comentarios,
            ],
          },
        },
      });
    }
  };

  const resetForm = () => {
    //console.log(addForm);
    setFormIsValid(false);
    setFormAutor('');
    setFormCorreo('');
    setFormContenido('');
  };

  const {
    loading: loadingComentarios,
    error: errorComentarios,
    data: dataComentarios,
  } = useQuery(GET_ARTICULO_COMENTARIOS, {
    variables: {
      paginate: {
        articulo: props.articuloId,
        numComentarios: 30,
        cursor: '',
        sortBy: { field: 'createdAt', order: 'ASC' },
      },
    },
    errorPolicy: 'all',
  });

  const [
    createComentario,
    {
      loading: loadingAddComentario,
      error: errorAddComentario,
      data: dataAddComentario,
    },
  ] = useMutation(ADD_COMENTARIO, {
    errorPolicy: 'all',
    update: updateCacheAdd,
    onCompleted: resetForm,
  });

  const comentarioHandler = (event) => {
    event.preventDefault();

    const comentarioData = {};
    for (let i in addForm) {
      comentarioData[i] = addForm[i].value;
    }

    //console.log(comentarioData);

    createComentario({
      variables: {
        input: {
          articulo: props.articuloId,
          autor: comentarioData.autor,
          correo: comentarioData.correo,
          contenido: comentarioData.contenido,
        },
      },
    });

    setAddForm({
      ...addForm,
      autor: {
        ...addForm.autor,
        value: '',
        valid: false,
        touched: false,
      },
      correo: {
        ...addForm.correo,
        value: '',
        valid: false,
        touched: false,
      },
      contenido: {
        ...addForm.contenido,
        value: '',
        valid: false,
        touched: false,
      },
    });
  };

  const [
    replyComentario,
    { loading: loadingReply, error: errorReply, data: dataReply },
  ] = useMutation(REPLY_COMENTARIO, {
    errorPolicy: 'all',
    //update: updateCacheDel,
    onCompleted: respuestaCloseModalHandler,
  });

  const respuestaComentarioHandler = (id, respuestaData) => {
    console.log(id, respuestaData);
    replyComentario({
      variables: {
        input: {
          id: id,
          respuesta: respuestaData.respuesta,
        },
      },
    });
  };

  let seccionComentarios = null;
  let showNotification = null;
  let respuestaComentarioModal = (
    <ArticuloRes
      show={respuestaModal}
      close={respuestaCloseModalHandler}
      respuestaComentario={respuestaComentarioHandler}
    />
  );

  if (loadingComentarios) {
    seccionComentarios = (
      <GridContainer justify='center'>
        <GridItem cs={12} sm={8} md={8}>
          <Spinner color='gray' />
        </GridItem>
      </GridContainer>
    );
  }
  if (loadingAddComentario) seccionComentarios = <Spinner color='gray' />;
  if (loadingReply) respuestaComentarioModal = <Spinner color='gray' />;

  if (errorComentarios) {
    seccionComentarios = (
      <GridContainer justify='center'>
        <GridItem cs={12} sm={8} md={8}>
          <h2 className={classes.title}>
            Error al buscar los comentarios del artículo.
          </h2>
        </GridItem>
      </GridContainer>
    );

    showNotification = errorComentarios.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorComentarios ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorAddComentario) {
    seccionComentarios = (
      <GridContainer justify='center'>
        <GridItem cs={12} sm={8} md={8}>
          <h2 className={classes.title}>Error al publicar comentario.</h2>
        </GridItem>
      </GridContainer>
    );

    showNotification = errorAddComentario.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorAddComentario ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorReply) {
    showNotification = errorReply.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorReply ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataComentarios && dataComentarios.getArticuloComentarios) {
    const { getArticuloComentarios } = dataComentarios;

    if (getArticuloComentarios.comentarios.length === 0) {
      seccionComentarios = (
        <GridContainer justify='center'>
          <GridItem cs={12} sm={8} md={8}>
            <div>
              <h3 className={classes.title}>
                No existen comentarios en el articulo por el momento.
              </h3>
            </div>
            <div className={classes.moveTo}>
              <h3 className={classes.titleComment}>Escribir un comentario</h3>
              <form onSubmit={comentarioHandler}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText='Nombre '
                      id='name'
                      success={formAutor === 'success'}
                      error={formAutor === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => {
                          inputChangedHandler(event.target.value, 'autor');
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText='Correo Electrónico '
                      id='email'
                      success={formCorreo === 'success'}
                      error={formCorreo === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => {
                          inputChangedHandler(event.target.value, 'correo');
                        },
                      }}
                    />
                  </GridItem>
                  <CustomInput
                    labelText='Comentario '
                    id='message'
                    success={formContenido === 'success'}
                    error={formContenido === 'error'}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.textArea,
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 5,
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'contenido');
                      },
                    }}
                  />
                  <GridItem
                    xs={12}
                    sm={4}
                    md={4}
                    className={classes.mrAuto + ' ' + classes.mlAuto}
                  >
                    <Button
                      type='submit'
                      color='dark'
                      round
                      disabled={!formIsValid}
                    >
                      Publicar Comentario
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
            </div>
          </GridItem>
        </GridContainer>
      );
    } else {
      seccionComentarios = (
        <GridContainer justify='center'>
          <GridItem cs={12} sm={8} md={8}>
            <div>
              <h3 className={classes.titleComment}>
                {getArticuloComentarios.totalCount} Comentarios
              </h3>
              {getArticuloComentarios.comentarios.map((comentario) => (
                <Media
                  key={comentario.node._id}
                  avatar={avatar}
                  title={
                    <span>
                      {comentario.node.autor}
                      <small>
                        · {timeDifferenceForDate(comentario.node.createdAt)}
                      </small>
                    </span>
                  }
                  body={
                    <span className={classes.color555}>
                      <p>{comentario.node.contenido}</p>
                      {props.estaAuth ? (
                        <Badge color='warning'>{comentario.node.correo}</Badge>
                      ) : null}
                    </span>
                  }
                  footer={
                    <div>
                      {props.estaAuth ? (
                        <Tooltip
                          id='tooltip-usuario'
                          title='Responder comentario'
                          placement='top'
                          classes={{ tooltip: classes.tooltip }}
                        >
                          <Button
                            color='dark'
                            simple
                            className={classes.footerButtons}
                            onClick={() =>
                              respuestaShowModalHandler(comentario.node._id)
                            }
                          >
                            <Reply className={classes.footerIcons} /> Responder
                          </Button>
                        </Tooltip>
                      ) : (
                        <Button
                          color='white'
                          simple
                          className={classes.footerButtons}
                        >
                          <Reply className={classes.footerIcons} /> OK
                        </Button>
                      )}
                    </div>
                  }
                  innerMedias={comentario.node.respuesta.map((resp) => (
                    <Media
                      key={comentario.node._id}
                      avatar={avatar}
                      title={
                        <span>
                          {resp.autor}
                          <small>
                            · {timeDifferenceForDate(resp.createdAt)}
                          </small>
                        </span>
                      }
                      body={
                        <span className={classes.color555}>
                          <p>{resp.respuesta}</p>
                          {/* <p>
                            Don{"'"}t forget, You{"'"}re Awesome!
                          </p> */}
                        </span>
                      }
                      // footer={
                      //   <Tooltip
                      //     id='tooltip-admin'
                      //     title='Responder comentario'
                      //     placement='top'
                      //     classes={{ tooltip: classes.tooltip }}
                      //   >
                      //     <Button
                      //       color='dark'
                      //       simple
                      //       className={classes.footerButtons}
                      //     >
                      //       <Reply className={classes.footerIcons} /> Responder
                      //     </Button>
                      //   </Tooltip>
                      // }
                    />
                  ))}
                />
              ))}
            </div>
            <div className={classes.moveTo}>
              <h3 className={classes.titleComment}>Escribir un comentario</h3>
              <form onSubmit={comentarioHandler}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText='Nombre '
                      id='name'
                      success={formAutor === 'success'}
                      error={formAutor === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => {
                          inputChangedHandler(event.target.value, 'autor');
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText='Correo Electrónico '
                      id='email'
                      success={formCorreo === 'success'}
                      error={formCorreo === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => {
                          inputChangedHandler(event.target.value, 'correo');
                        },
                      }}
                    />
                  </GridItem>
                  <CustomInput
                    labelText='Comentario '
                    id='message'
                    success={formContenido === 'success'}
                    error={formContenido === 'error'}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.textArea,
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 5,
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'contenido');
                      },
                    }}
                  />
                  <GridItem
                    xs={12}
                    sm={4}
                    md={4}
                    className={classes.mrAuto + ' ' + classes.mlAuto}
                  >
                    <Button
                      type='submit'
                      color='dark'
                      round
                      disabled={!formIsValid}
                    >
                      Publicar Comentario
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
            </div>
          </GridItem>
        </GridContainer>
      );
    }
  }
  if (dataAddComentario && dataAddComentario.createComentario) {
    const { createComentario } = dataAddComentario;
    if (createComentario.success && createComentario.code === '201') {
      showNotification = (
        <Notification
          key={createComentario.code}
          mostrar={createComentario.success ? true : false}
          msg={createComentario.message}
          stt={createComentario.success}
        />
      );
    }
  }

  if (dataReply && dataReply.replyComentario) {
    const { replyComentario } = dataReply;
    if (replyComentario.success && replyComentario.code === '200') {
      showNotification = (
        <Notification
          key={replyComentario.code}
          mostrar={replyComentario.success ? true : false}
          msg={replyComentario.message}
          stt={replyComentario.success}
        />
      );
    }
  }

  return (
    <Fragment>
      {seccionComentarios}
      {respuestaComentarioModal}
      {showNotification}
    </Fragment>
  );
};

export default ArticuloComment;
